import { render, staticRenderFns } from "./PageButtonEditor.vue?vue&type=template&id=57509683&scoped=true&"
import script from "./PageButtonEditor.vue?vue&type=script&lang=js&"
export * from "./PageButtonEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageButtonEditor.vue?vue&type=style&index=0&id=57509683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57509683",
  null
  
)

export default component.exports